import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeftShimmerComponent } from './left-shimmer/left-shimmer.component';
import { PrimaryShimmerComponent } from './primary-shimmer/primary-shimmer.component';
import { MapShimmerComponent } from './map-shimmer/map-shimmer.component';
import { EstimateShimmerComponent } from './estimate-shimmer/estimate-shimmer.component';
import { SidebarShimmerComponent } from './sidebar-shimmer/sidebar-shimmer.component';
import { ZuperShimmerLoadingModule } from '../zuper-shimmer-loading/zuper-shimmer-loading.module';



@NgModule({
  declarations: [
    LeftShimmerComponent,
    PrimaryShimmerComponent,
    MapShimmerComponent,
    EstimateShimmerComponent,
    SidebarShimmerComponent
  ],
  imports: [
    CommonModule,
    ZuperShimmerLoadingModule
  ],
  exports: [
    LeftShimmerComponent,
    PrimaryShimmerComponent,
    MapShimmerComponent,
    EstimateShimmerComponent,
    SidebarShimmerComponent
  ]
})
export class ShimmerModule { }
